import {Component, ElementRef, inject, ChangeDetectionStrategy} from '@angular/core';
import {IE3InputDeclareTranshipment} from "@portbase/bezoekschip-service-typescriptmodels";
import {checkValidity, sendCommand} from "../../../../common/utils";
import {AppContext} from "../../../../app-context";

@Component({
    selector: 'app-declare-transhipment-bulk-consignment',
    templateUrl: './declare-transhipment-bulk-consignment.component.html',
    styleUrls: ['./declare-transhipment-bulk-consignment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeclareTranshipmentBulkConsignmentComponent {
  private element: ElementRef = inject(ElementRef);

  crn: string;
  consignmentNumber: string;

  reset() {
    this.crn = '';
    this.consignmentNumber = '';
  }

  submit() {
    if (checkValidity(this.element)) {
      const declaration = <IE3InputDeclareTranshipment>{
        consignmentNumber: this.consignmentNumber,
        crn: this.crn
      }

      sendCommand(
        'com.portbase.bezoekschip.common.api.consignments.commands.input.InputDeclareTranshipment', declaration,
        () => AppContext.registerSuccess("Declaration transhipment sent successfully"));
    }
  }
}
